export const state = () => ({
  col: 4,
  row: 2,
  image: null,
  selectedMenuForGrid: null,
  gridConfiguration: null,
  loadingGrid: false,
  paddingGrid: 0,
  selectGridItem: null,
  selectGridItemConfiguration: null,
  gridTemplateArea: '',
  updateMenuGridConfigurationSuccess: null,
  cache: null,
  aspectRatio: '16 / 9',
  backgroundImageSizeBehaviour: 'contain',
  menuGridItemList: [],
  clausesList: [],
  gridItemToDelete: null,
  openPortal: false,
});
